module.exports = __webpack_public_path__ + "static/hero-1-a59c3281ca9db4d77762cc712bcf157c.jpg";